const ID_TOKEN_KEY = "id_token";
const JOBSEEKER_TOKEN_KEY = "soha_jobseeker_token";
const EXPIRES_IN_KEY = "expires_in";
const COMPANY_ID = "companyId";
const USER_ID = "userId";
const REFRESH_TOKEN_KEY = "refresh_token";
const JOBSEEKER_REFRESH_TOKEN_KEY = "soha_jobseeker_refresh_token";

// ============ GETTERS ============
export const getCompanyId = () => localStorage.getItem(COMPANY_ID);
export const getUserId = () => localStorage.getItem(USER_ID);

export const getToken = () => localStorage.getItem(ID_TOKEN_KEY);
export const getJobseekerToken = () => localStorage.getItem(JOBSEEKER_TOKEN_KEY);

export const getExpiresIn = () => localStorage.getItem(EXPIRES_IN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const getJobseekerRefreshToken = () =>
  localStorage.getItem(JOBSEEKER_REFRESH_TOKEN_KEY);

// ============ SETTERS ============
export const saveToken = ({ token, expiresIn, refreshToken }) => {
  if (token) localStorage.setItem(ID_TOKEN_KEY, token);
  if (expiresIn) localStorage.setItem(EXPIRES_IN_KEY, expiresIn);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const saveJobseekerToken = ({ accessToken, refreshToken }) => {
  if (accessToken) localStorage.setItem(JOBSEEKER_TOKEN_KEY, accessToken);
  if (refreshToken)
    localStorage.setItem(JOBSEEKER_REFRESH_TOKEN_KEY, refreshToken);
};

export const saveCompanyId = (data) => localStorage.setItem(COMPANY_ID, data);
export const saveUserId = (data) => localStorage.setItem(USER_ID, data);

// ============ DESTROY ============
export const destroyToken = () => {
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(EXPIRES_IN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const destroyJobseekerToken = () => {
  localStorage.removeItem(JOBSEEKER_TOKEN_KEY);
  localStorage.removeItem(JOBSEEKER_REFRESH_TOKEN_KEY);
};

export default {
  getToken,
  getJobseekerToken,
  getRefreshToken,
  getJobseekerRefreshToken,
  saveToken,
  saveJobseekerToken,
  destroyToken,
  destroyJobseekerToken,
  saveCompanyId,
  saveUserId,
};
